import { createActionsHook } from 'src/lib/sweetState';

import { FormatStore } from './FormatStore';

export const useFormatActions = createActionsHook(FormatStore);
